var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 55,
    viewBox: "0 0 69 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.501953,
    width: 68.5887,
    height: 54,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0341 24.8269H58.2215C58.5521 24.8269 58.8758 24.9208 59.1551 25.0975L64.8975 28.7323C65.4031 29.0523 65.7095 29.6089 65.7095 30.2072V40.4455C65.7095 40.5922 65.6959 40.7406 65.6317 40.8725C65.3937 41.3612 64.6915 42.0603 63.1967 42.0603H59.7388C58.8783 39.8032 56.6935 38.1999 54.1342 38.1999C51.5749 38.1999 49.3901 39.8032 48.5296 42.0603H44.0311C43.0671 42.0603 42.2886 41.2788 42.2886 40.3148V26.5724C42.2886 25.6084 43.0701 24.8269 44.0341 24.8269Z",
    fill: "#F3BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5601 23.7578H58.4V25.6429H42.5601V23.7578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93115 6.38045C1.93115 4.99228 3.05649 3.86694 4.44466 3.86694H40.9898C42.3779 3.86694 43.5033 4.99228 43.5033 6.38045V40.5364C43.5033 41.9245 42.3779 43.0499 40.9898 43.0499H18.2504V41.1647H40.9898C41.3368 41.1647 41.6181 40.8834 41.6181 40.5364V6.38045C41.6181 6.03341 41.3368 5.75207 40.9898 5.75207H4.44466C4.09762 5.75207 3.81628 6.03341 3.81628 6.38045V40.5364C3.81628 40.8834 4.09762 41.1647 4.44466 41.1647H6.94301V43.0499H4.44466C3.05649 43.0499 1.93115 41.9245 1.93115 40.5364V6.38045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0368 8.13574C9.55737 8.13574 9.97937 8.55774 9.97937 9.07831V29.1138C9.97937 29.6343 9.55737 30.0563 9.0368 30.0563C8.51624 30.0563 8.09424 29.6343 8.09424 29.1138V9.07831C8.09424 8.55774 8.51624 8.13574 9.0368 8.13574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8395 8.13574C16.3601 8.13574 16.7821 8.55774 16.7821 9.07831V29.1138C16.7821 29.6343 16.3601 30.0563 15.8395 30.0563C15.319 30.0563 14.897 29.6343 14.897 29.1138V9.07831C14.897 8.55774 15.319 8.13574 15.8395 8.13574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6418 8.13574C23.1623 8.13574 23.5843 8.55774 23.5843 9.07831V29.1138C23.5843 29.6343 23.1623 30.0563 22.6418 30.0563C22.1212 30.0563 21.6992 29.6343 21.6992 29.1138V9.07831C21.6992 8.55774 22.1212 8.13574 22.6418 8.13574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4445 8.13574C29.9651 8.13574 30.3871 8.55774 30.3871 9.07831V29.1138C30.3871 29.6343 29.9651 30.0563 29.4445 30.0563C28.924 30.0563 28.502 29.6343 28.502 29.1138V9.07831C28.502 8.55774 28.924 8.13574 29.4445 8.13574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2473 8.13574C36.7678 8.13574 37.1898 8.55774 37.1898 9.07831V29.1138C37.1898 29.6343 36.7678 30.0563 36.2473 30.0563C35.7267 30.0563 35.3047 29.6343 35.3047 29.1138V9.07831C35.3047 8.55774 35.7267 8.13574 36.2473 8.13574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5591 34.7626H2.87207V32.8774H42.5591V34.7626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6082 15.3729H42.5605V13.4878H51.6082C53.359 13.4878 54.9458 14.5181 55.6581 16.1173L59.023 23.671C59.0942 23.8308 59.2156 23.963 59.3689 24.0475L64.3602 26.7981C65.7751 27.5778 66.6539 29.0655 66.6539 30.681V40.3613C66.6539 41.8458 65.4504 43.0493 63.9658 43.0493H59.7105V41.1642H63.9658C64.4093 41.1642 64.7687 40.8047 64.7687 40.3613V30.681C64.7687 29.7524 64.2636 28.8973 63.4503 28.4491L58.459 25.6985C57.946 25.4158 57.5393 24.9732 57.301 24.4381L53.9361 16.8844C53.5267 15.9651 52.6146 15.3729 51.6082 15.3729ZM40.1904 41.1642H48.6292V43.0493H40.1904V41.1642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6228 39.142C9.83178 39.142 7.56921 41.4045 7.56921 44.1955C7.56921 46.9866 9.83178 49.2491 12.6228 49.2491C15.4138 49.2491 17.6764 46.9866 17.6764 44.1955C17.6764 41.4045 15.4138 39.142 12.6228 39.142ZM5.68408 44.1955C5.68408 40.3634 8.79065 37.2568 12.6228 37.2568C16.4549 37.2568 19.5615 40.3634 19.5615 44.1955C19.5615 48.0277 16.4549 51.1343 12.6228 51.1343C8.79065 51.1343 5.68408 48.0277 5.68408 44.1955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1355 39.142C51.3445 39.142 49.0819 41.4045 49.0819 44.1955C49.0819 46.9866 51.3445 49.2491 54.1355 49.2491C56.9265 49.2491 59.1891 46.9866 59.1891 44.1955C59.1891 41.4045 56.9265 39.142 54.1355 39.142ZM47.1968 44.1955C47.1968 40.3634 50.3033 37.2568 54.1355 37.2568C57.9676 37.2568 61.0742 40.3634 61.0742 44.1955C61.0742 48.0277 57.9676 51.1343 54.1355 51.1343C50.3033 51.1343 47.1968 48.0277 47.1968 44.1955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5156 29.2455C45.5156 28.725 45.9376 28.303 46.4582 28.303H50.1582C50.6788 28.303 51.1008 28.725 51.1008 29.2455C51.1008 29.7661 50.6788 30.1881 50.1582 30.1881H46.4582C45.9376 30.1881 45.5156 29.7661 45.5156 29.2455Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.7c536878951fa4b39802dc8c23a795d9.svg";
export { ForwardRef as ReactComponent };